import { AddressResponse } from "libs/shared-models/src/lib/address-response";
import { OrderCreateRequest, OrderLineItemCreateRequest } from "./order-create-request";

/*
  Similar to the request one, only with few additional attributes (id, status)
*/
export class OrderResponse extends OrderCreateRequest {
  id: string = "";
  status: OrderStatus;
  slug: string = "";
  restaurantAddress: AddressResponse = new AddressResponse();
  createdDate: string;
  lastModifiedDate: string;
  stripePaymentIntent: string;
  statusTimestamps: any;
  restaurantLogoImageUrl: string;
  restaurantMainImageUrl: string;
  deliveryProvider: DeliveryProvider;
  review: ReviewResponse;
  override items: OrderLineItemResponse[] = [];
}

/*
  This one is the same as the created request one
*/
export class OrderLineItemResponse extends OrderLineItemCreateRequest{
}

/*
  Used in the orders list page / paginated response
*/
export class OrderListResponse {
  results: OrderResponse[] = [];
  pageNumber: number = 0;
  pageSize: number = 0;
  pageTotal: number = 0;
  totalItems: number = 0;
}

export class ReviewResponse {
    comment: string = "";
    createdDate: string = "";
    id: string = "";
    orderId: string = "";
    orderSlug: string = "";
    rating: number = 0;
}


export enum OrderStatus {
  CREATED = "CREATED",
  PENDING_PAYMENT = "PENDING_PAYMENT", // newer - needs implementation to cover
  PAYMENT_FAILED = "PAYMENT_FAILED",
  PAID = "PAID",
  ACCEPTED_BY_RESTAURANT = "ACCEPTED_BY_RESTAURANT",
  DECLINED_BY_RESTAURANT = "DECLINED_BY_RESTAURANT",
  PREPARING = "PREPARING", // newer - needs implementation to cover  
  IN_DELIVERY = "IN_DELIVERY", // TODO: DELETE THIS ONE AND MAP THE NXT TWOS:
  READY_FOR_PICKUP = "READY_FOR_PICKUP", // newer - needs implementation to cover
  OUT_FOR_DELIVERY = "OUT_FOR_DELIVERY", // newer - needs implementation to cover
  DELIVERED = "DELIVERED",
  CANCELLED = "CANCELLED", // newer - needs implementation to cover
  REFUNDED = "REFUNDED" // newer - needs implementation to cover
}

export enum DeliveryProvider {
  OWN_DELIVERY = "OWN_DELIVERY",
  EXTERNAL_DELIVERY = "EXTERNAL_DELIVERY"
}